// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var heroContainer = "Hero-module--heroContainer--22Wzf";
export var mosaic = "Hero-module--mosaic--utt7O";
export var mosaicHero = "Hero-module--mosaicHero--3SyYp";
export var formHero = "Hero-module--formHero--OlCid";
export var imageContainer = "Hero-module--imageContainer--2gRGe";
export var contentContainer = "Hero-module--contentContainer--yHhgZ";
export var textContainer = "Hero-module--textContainer--1Ux1L";
export var title = "Hero-module--title--34ejl";
export var text = "Hero-module--text--3fEb3";
export var textOverTitleContainer = "Hero-module--textOverTitleContainer--2Og4U";
export var textOverTitle = "Hero-module--textOverTitle--XdPxd";
export var formContainer = "Hero-module--formContainer--1hY0e";
export var formTitleAndTextContainer = "Hero-module--formTitleAndTextContainer--znCRU";
export var formTitle = "Hero-module--formTitle--1nz6B";
export var protectedText = "Hero-module--protectedText--3jE11";
export var element = "Hero-module--element--z86uX";
export var mosaicTextBar = "Hero-module--mosaicTextBar--1tyba";
export var mosaicBar = "Hero-module--mosaicBar--1thmM";
export var mosaicImagesContainer = "Hero-module--mosaicImagesContainer--tXIuQ";
export var mosaicImage = "Hero-module--mosaicImage--1YnuM";
export var fullWidthHero = "Hero-module--fullWidthHero--zCQ8y";
export var fullWithImage = "Hero-module--fullWithImage--391pW";
export var noMobileImage = "Hero-module--noMobileImage--3_xVH";
export var titleContainer = "Hero-module--titleContainer--2V3K5";
export var mobileImage = "Hero-module--mobileImage--1NdOf";